<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.MultiSegmentNumberRuleConfiguration')"
    width="360px"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <div class="app-main-inner-row">
      <el-form label-width="60px" label-position="left">
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('SeaExport.StartNumber')">
            <el-input v-model.trim="rulesForm.startNum" no="1" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NumberOfCopies')">
            <el-input-number v-model="rulesForm.numStep" no="2" :min="1" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.IncrementalRule')">
            <el-select v-model="rulesForm.rule" no="3">
              <el-option
                v-for="item in ruleOptions"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div slot="footer" style="text-align: center;">
      <el-button no="4" type="primary" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="5" @click="cancel">{{ $t('common.btn.cancel') }}</el-button>
      <el-button no="6" type="primary" @click="exportHandle">{{ $t('SeaExport.DirectExport') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Assert } from '@/utils/validate'

export default {
  name: 'MultiSegNumRulesDialog',
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      initRulesForm: {
        startNum: '',
        numStep: 1,
        rule: 0
      },
      rulesForm: {},
      ruleOptions: [
        {
          label: this.$t('SeaExport.Plus1'),
          value: 0
        }, {
          label: this.$t('SeaExport.Plus10'),
          value: 1
        }, {
          label: 'A-Z',
          value: 2
        }
      ]
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.rulesForm = { ...this.initRulesForm }
      }
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async confirm() {
      const { startNum, numStep, rule } = { ...this.rulesForm }
      await Assert.isNotBlank(startNum, this.$t('SeaExport.TheNumberCannotBeEmpty'))
      await Assert.isNumber(startNum.substring(startNum.length - 1), this.$t('SeaExport.IllegalNumberEntry'))
      await Assert.isTrue(numStep > 0, this.$t('SeaExport.TheMustBeGreaterZero'))
      await Assert.isNotBlank(rule, this.$t('SeaExport.IncrementRuleIsNotSelected'))

      // 构建ruleEDINos
      let ruleEDINos
      switch (this.rulesForm.rule) {
        case 0:
          ruleEDINos = this.buildNos().getAddN(1)
          break
        case 1:
          ruleEDINos = this.buildNos().getAddN(10)
          break
        case 2:
          ruleEDINos = this.buildNos().getEnChar()
          break
        default:
          ruleEDINos = []
      }
      this.innerVisible = false
      this.$emit('callback', ruleEDINos)
    },
    cancel() {
      this.innerVisible = false
    },
    exportHandle() {
      this.innerVisible = false
      this.$emit('callback', null)
    },
    buildNos() {
      const nums = this.rulesForm.numStep
      const startNum = this.rulesForm.startNum.trim()
      const STR_E = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
      // 加n 用来代替之前的getAddOnes & 用来代替之前的getAddTens两个方法
      const getAddN = (addStep) => {
        const result = []
        const nos = getRuleNoArray()
        const nums = this.rulesForm.numStep
        const startStr = nos[0]
        const startNum = Number(nos[1])

        for (let i = 0; i < nums; i++) {
          result.push(startStr + reairZero(nos[1], String(startNum + i * addStep)))
        }
        return result
      }
      // A-Z
      const getEnChar = () => {
        const result = []
        for (let i = 0; i < nums; i++) {
          result.push(startNum + STR_E[i])
        }
        return result
      }
      const getRuleNoArray = () => {
        const result = []
        let i = 0
        for (i = startNum.length; i >= 0; i--) {
          if (isNaN(Number(startNum.charAt(i)))) {
            break
          }
        }
        result.push(startNum.substring(0, i + 1))
        result.push(startNum.substring(i + 1))
        return result
      }
      const reairZero = (source, s) => {
        const len = source.length - s.length
        for (let i = 0; i < len; i++) {
          s = '0' + s
        }
        return s
      }
      return { getAddN, getEnChar }
    }
  }
}
</script>
